// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__p1tsM","main":"Dashboard_main__FOlJ7"};